var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWristwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4369 2C8.535 2 7.74468 2.60364 7.50737 3.47377L6.60205 6.79328C7.96609 5.3794 9.88046 4.5 12.0002 4.5C14.12 4.5 16.0343 5.3794 17.3984 6.79328L16.4931 3.47377C16.2558 2.60364 15.4654 2 14.5635 2H9.4369Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60205 17.2067C7.96609 18.6206 9.88046 19.5 12.0002 19.5C14.12 19.5 16.0343 18.6206 17.3984 17.2067L16.4931 20.5262C16.2558 21.3964 15.4654 22 14.5635 22H9.4369C8.535 22 7.74468 21.3964 7.50737 20.5262L6.60205 17.2067Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12.75 9V11.6893L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V9C11.25 8.58579 11.5858 8.25 12 8.25C12.4142 8.25 12.75 8.58579 12.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWristwatch);
export default __webpack_public_path__ + "static/media/wristwatch.0554a1511086c82faeae29a266bf1ec2.svg";
export { ForwardRef as ReactComponent };